/**
 * Regras alinhadas ao backend (HrManager.document como CPF numérico + Global::PHONE_NUMBER_REGEXP).
 */
export function isManagerDocumentDigitsComplete(document: string | undefined): boolean {
  return (document ?? '').replace(/\D/g, '').length === 11;
}

export function isManagerPhoneDigitsComplete(phone: string | undefined): boolean {
  const digits = (phone ?? '').replace(/\D/g, '');
  return /^55\d{10,11}$/.test(digits);
}

export function isManagerContactProfileComplete(document: string | undefined, phone: string | undefined): boolean {
  return isManagerDocumentDigitsComplete(document) && isManagerPhoneDigitsComplete(phone);
}
